import { render, staticRenderFns } from "./VriendenVan.vue?vue&type=template&id=64c08243&scoped=true&"
import script from "./VriendenVan.vue?vue&type=script&lang=js&"
export * from "./VriendenVan.vue?vue&type=script&lang=js&"
import style0 from "./VriendenVan.vue?vue&type=style&index=0&id=64c08243&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c08243",
  null
  
)

export default component.exports